export const API_IDS = {
  //GOLDMAN SACHS LONGLEAT APIS
  CMS_DOCUMENT_LIST: `cmsDocumentList`,
  CMS_DOCUMENT_FILE_DOWNLOAD: `cmsDocumentFileDownload`,
  DM_DOCUMENT_LIST: `dmDocumentList`,
  DM_DOCUMENT_FILE_DOWNLOAD: `dmDocumentFileDownload`,
  SECURITIES_SUSPENSIONS: `securitiesSuspensions`,
  HISTORIC_SECURITIES_SUSPENSIONS: `historicSecuritiesSuspensions`,
  SECURITIES_UPDATES: `securitiesUpdates`,
  RSS_XML_DOWNLOAD: `rssXmlDownload`,
  SUBSCRIBE_ALERTS: `addToMailingList`
};

export const APIS = {
  cmsDocumentList: `goldmansachs-longleat-api/v1/GetCmsDocumentList`,
  cmsDocumentFileDownload: `goldmansachs-longleat-api/v1/GetCmsDocumentFileDownload`,
  dmDocumentList: `goldmansachs-longleat-api/v1/GetDMDocumentList`,
  dmDocumentFileDownload: `goldmansachs-longleat-api/v1/GetDMDocumentFileDownload`,
  securitiesSuspensions: `goldmansachs-longleat-api/v1/GetSecuritiesSuspensionsGetNew`,
  historicSecuritiesSuspensions: `goldmansachs-longleat-api/v1/GetSecuritiesSuspensions`,
  securitiesUpdates: `goldmansachs-longleat-api/v1/GetSecuritiesUpdates`,
  rssXmlDownload: `goldmansachs-longleat-api/v1/GetRssXml/{Id}`,
  addToMailingList: `goldmansachs-longleat-api/v1/AddToEmailDistributionList`
};

export const API_TYPES = {
  MARKIT_DIGITAL_API: 'MARKIT_DIGITAL_API',
};

export const BASE_URLS = {
  MARKIT_DIGITAL_API: {
    localhost: 'https://goldmansachs.api.wsodqa.com',
    development: 'https://api.dev.services.mdgapp.net',
    acceptance: 'https://goldmansachs.api.wsodqa.com',
    acceptance2: 'https://goldmansachs.api.wsodqa.com',
    production: 'https://goldmansachs.api.wsod.com',
    unknown: 'https://goldmansachs.api.wsodqa.com',
  } 
};
